import { render, staticRenderFns } from "./CompetitionListPhotoLayout.vue?vue&type=template&id=39c6036e&scoped=true"
import script from "./CompetitionListPhotoLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionListPhotoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6036e",
  null
  
)

export default component.exports